import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

const labelStyle = {
  display: "block",
  position: "absolute",
  paddingLeft: 16,
  paddingRight: 8,
  paddingBottom: 275,
  verticalAlign: "middle",
  letterSpacing: 0,
  textTransform: "uppercase",
  fontWeight: "500",
  fontSize: 15
};

const MapButton = props => (
  <Button
    variant="text"
    onClick={props.onClick}
    style={{ height: 325, width: "100%", paddingLeft: 20, paddingRight: 20 }}
  >
    <div style={labelStyle}>{props.label}</div>
    <div>
      <img
        src={props.img}
        alt={props.label}
        style={{ paddingTop: 30, maxHeight: 250, maxWidth: 250 }}
      />
    </div>
  </Button>
);

MapButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired
};

export default MapButton;
